import { useState } from 'react'
import AuthService from 'services/auth'
import cutileiApi from 'services/cutileiApi'
import { logApiError } from 'services/apiError'
import AlertDialog from 'components/AlertDialog'
import { ReactComponent as ButtonLoading } from 'icons/loading2.svg'
import * as FA from 'react-icons/fa'
import { DateTime } from 'luxon'

import {
  Container,
  Row,
  InfoText,
  Button
} from './styles'

export default function ExceptionalDate ({
  data: exceptionalDate,
  onEdit: handleEdit,
  onDelete: handleDelete
}) {
  const [showDeleteExceptionalDateDialog, setShowDeleteExceptionalDateDialog] = useState (false)
  const [deleting, setDeleting] = useState (false)
  const businessId = AuthService.getBusinessId ()
  const token = AuthService.getToken ()

  const requestConfig = {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  }

  const getPeriod = exceptionalDate => {
    const period = DateTime.fromISO (exceptionalDate.end_date)
      .diff (DateTime.fromISO (exceptionalDate.start_date), 'days').toObject ()

    return period.days > 0 ? `${period.days} dias` : '1 dia'
  }

  const period = getPeriod (exceptionalDate)

  const deleteExceptionalDate = async () => {
    try {
      setDeleting (true)
      await cutileiApi.delete (
        `/businesses/${businessId}/exceptional_dates/${exceptionalDate.id}`,
        requestConfig
      )
      
      handleDelete (exceptionalDate)
    } catch (error) {
      logApiError (error)
    } finally {
      setDeleting (false)
    }
  }

  const toggleDeleteExceptionalDateDialog = () => (
    setShowDeleteExceptionalDateDialog (!showDeleteExceptionalDateDialog)
  )

  return (
    <Container>
      <InfoText>
        {exceptionalDate.description}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (exceptionalDate.start_date).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <InfoText>
        {DateTime.fromISO (exceptionalDate.end_date).toFormat ('dd/MM/yyyy')}
      </InfoText>
      <InfoText>
        {period}
      </InfoText>
      <InfoText>
        {exceptionalDate.start_time}
      </InfoText>
      <InfoText>
        {exceptionalDate.end_time}
      </InfoText>
      <Row>
        {AuthService.hasPermission ('business_config.agenda', 'edit') && (
          <Button onClick={() => handleEdit (exceptionalDate)}>
            <FA.FaEdit color='#35A7FF' size={18}/>
          </Button>
        )}
        {AuthService.hasPermission ('business_config.agenda', 'delete') && (
          <Button onClick={toggleDeleteExceptionalDateDialog}>
            {deleting ? (
              <ButtonLoading style={{margin: 0}}/>
            ) : (
              <FA.FaTrash color='#FF3939' size={16}/>
            )}
          </Button>
        )}
      </Row>
      <AlertDialog
        visible={showDeleteExceptionalDateDialog}
        title='Atenção!'
        message='Deseja realmente excluir esta data excepcional?'
        confirmText='Sim'
        cancelText='Não'
        onConfirm={deleteExceptionalDate}
        onClose={toggleDeleteExceptionalDateDialog}
        dangerous={true}
      />
    </Container>
  )
}
